<script lang="ts">
  /**
   * The name a seat is taken under, asked only where a seat is about to be
   * taken (the start screen's questions, the join card's seat question). A
   * signed-in player plays as their account, so there is nothing to ask: a
   * line says so. A guest gets the shell's `Field` in its seat dress,
   * remembered on this device.
   *
   * `name` is bindable: the screen that owns it sends it with the join.
   */
  import { Field } from '@artibens/app-shell';

  import { account } from '../state/account.svelte.js';

  let {
    name = $bindable(''),
    input = $bindable(undefined),
    onenter,
    autofocus = false,
  }: {
    name?: string;
    input?: HTMLInputElement | undefined;
    onenter?: (() => void) | undefined;
    /** Asks for focus when the sheet this sits in opens: for a guest with no name yet. */
    autofocus?: boolean;
  } = $props();

  const player = $derived(account.status === 'signed-in' ? account.player : null);

  // Signed in (or just signed in while this was open): the seat is the
  // account's.
  $effect(() => {
    if (player !== null && name !== player.username) name = player.username;
  });
</script>

{#if player}
  <p class="play-as" data-testid="playing-as">Playing as {player.username}</p>
{:else}
  <Field
    variant="seat"
    label="Display name"
    placeholder="Guest"
    maxlength={16}
    autocomplete="nickname"
    bind:value={name}
    bind:input
    {onenter}
    {autofocus}
    testid="play-as-name"
  />
{/if}

<style>
  .play-as {
    margin: 0;
    font: var(--ui-text-label);
    color: var(--ui-ink-2);
  }
</style>
